import { z } from "zod";

export const schema = z.object({
  handoffId: z.string().min(1, "handoffId is required"),
});

export type InputType = z.infer<typeof schema>;

export type OutputType =
  | { status: "pending" }
  | { status: "ready"; tempToken: string; provider: string }
  | {
      status: "error";
      message: string;
      code?: string;
      details?: string;
      provider: string;
    }
  | { status: "expired" };

export const getAuthOauthHandoff = async (
  params: InputType,
  init?: RequestInit
): Promise<OutputType> => {
  const validatedInput = schema.parse(params);
  const searchParams = new URLSearchParams({ handoffId: validatedInput.handoffId });
  
  const result = await fetch(`/_api/auth/oauth_handoff?${searchParams.toString()}`, {
    method: "GET",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  
  if (!result.ok) {
    let errorMessage = result.statusText;
    try {
      const errorObject = await result.json();
      if (errorObject.error) errorMessage = errorObject.error;
    } catch {
      // Ignored
    }
    throw new Error(errorMessage);
  }
  
  return result.json() as Promise<OutputType>;
};